<script>
  export let content;

  let visible = false;

  const handleEnter = () => {
    visible = true;
  };

  const handleLeave = () => {
    visible = false;
  };
</script>

<div class="wrapper" on:mouseenter={handleEnter} on:mouseleave={handleLeave}>
  <slot />
  {#if visible}
    <div class="inner-wrapper">
      <div class="content">
        {content}
      </div>
    </div>
  {/if}
</div>

<style>
  .wrapper {
    position: relative;
    display: inline-block;
  }

  .inner-wrapper {
    position: absolute;
    z-index: 9999;
    top: 45px;
    left: -86px;
    width: 200px;
  }

  .inner-wrapper:before {
    content: "";
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    background: #fff;
    position: absolute;
    z-index: 9999;
    top: -10px;
    border-left: 1px solid #eee;
    border-top: 1px solid #eee;
    left: calc(50% - 10px);
  }

  .content {
    padding: 12px;
    font-size: 12px;
    text-align: center;
    color: #999;
    background-color: white;
    border: 1px solid #eee;
    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.25);
  }
</style>
